import { useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { useAuth } from "../lib/auth";

/**
 * Pulsante "SA" (Super Admin) fluttuante in basso a destra.
 * Visibile **solo agli admin autenticati** o ai visitatori non loggati.
 * Per gli utenti normali (clienti del ristorante) NON viene mostrato.
 */
export function SuperAdminFab() {
    const navigate = useNavigate();
    const { user, loading } = useAuth();
    // Durante il loading non mostra nulla per evitare flash
    if (loading) return null;
    // Se c'è un utente loggato che NON è admin, nascondi il pulsante.
    // Gli admin (e i visitatori anonimi che vogliono accedere all'area admin)
    // continuano a vederlo.
    if (user && !user.is_admin) return null;
    return (
        <button
            type="button"
            onClick={() => navigate("/admin")}
            title="Accesso area Super Admin"
            aria-label="Super Admin"
            data-testid="super-admin-fab"
            className="
                fixed bottom-4 right-4 z-40
                h-11 w-11 sm:h-12 sm:w-12
                rounded-full
                bg-brand-navy text-brand-gold
                shadow-card border border-brand-gold/50
                flex items-center justify-center
                hover:bg-brand-navyLight hover:scale-105
                transition-transform
                print:hidden
            "
        >
            <Shield size={16} className="absolute opacity-30" />
            <span className="font-display font-bold text-[12px] tracking-wider relative">SA</span>
        </button>
    );
}
